/* ===========================================================================
   NasoStrips · Código de descuento visible
   ---------------------------------------------------------------------------
   Quien escanea un QR entra por /discount/CODIGO: Shopify deja el código
   enganchado al carrito, pero hasta ahora la web no lo decía en ninguna parte.
   Este archivo lo cuenta en cuatro sitios: la franja de arriba, una bienvenida
   la primera vez, el precio con el código junto a cada precio, y la fila del
   carrito con su nombre.

   La verdad de lo que se cobra siempre sale de Shopify (/cart.js). Con el
   carrito vacío, Shopify no dice cuánto descuenta un código ni si existe, así
   que el porcentaje sale de la lista del editor; un código que no esté en ella
   se calla hasta que Shopify confirme el descuento con algo en el carrito.
   =========================================================================== */
(function () {
  'use strict';

  var confEl = document.getElementById('nsq-conf');
  if (!confEl) return;

  var conf;
  try { conf = JSON.parse(confEl.textContent); } catch (e) { return; }
  if (!conf) return;

  // -- Lista del editor: "CODIGO|15|frase" por línea -------------------------
  var CODES = {};
  String(conf.list || '').split('\n').forEach(function (line) {
    var p = line.split('|');
    var code = (p[0] || '').trim().toUpperCase();
    if (!code || code.charAt(0) === '#') return;
    var pct = parseFloat(String(p[1] || '').replace(',', '.').replace('%', ''));
    CODES[code] = {
      pct: isNaN(pct) || pct <= 0 || pct >= 100 ? null : pct,
      phrase: (p[2] || '').trim()
    };
  });

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  /* Cuánto vale un código desde que se escanea. Pasado ese tiempo se retira:
     el cliente que escaneó hace meses no debe encontrarse un código antiguo
     puesto sin haber hecho nada. */
  var DIAS = parseInt(conf.dias, 10);
  if (!DIAS || DIAS < 1) DIAS = 30;
  var MEM = 'nsq-origen';
  var ajustando = false;

  function recuerdo() {
    try { return JSON.parse(window.localStorage.getItem(MEM) || 'null'); } catch (e) { return null; }
  }
  function recordar(code) {
    try { window.localStorage.setItem(MEM, JSON.stringify({ code: code, ts: Date.now() })); } catch (e) { /* modo privado */ }
  }
  function olvidar() {
    try { window.localStorage.removeItem(MEM); } catch (e) { /* modo privado */ }
  }

  var state = { code: null, codes: [], pct: null, phrase: '', rejected: false, items: 0 };
  var sheetShown = false;

  // -- Utilidades ------------------------------------------------------------
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Shopify trunca los céntimos del descuento (16,90 € al 15 % = −2,53 €, no
  // −2,54 €). Comprobado con carritos reales antes de escribir esto.
  function withCode(cents, pct) {
    return cents - Math.floor((cents * pct) / 100);
  }

  function parseCents(text) {
    if (!text) return null;
    var t = String(text).replace(/ |\s/g, '');
    var m = t.match(/(\d{1,3}(?:\.\d{3})*|\d+)[,](\d{2})/);
    if (m) return parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
    m = t.match(/(\d+)(?:€|EUR)/);
    return m ? parseInt(m[1], 10) * 100 : null;
  }

  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function urlCode() {
    try { return new URLSearchParams(window.location.search).get('discount'); } catch (e) { return null; }
  }

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { /* navegación privada: seguimos sin recordar nada */ }
    return null;
  }

  /* `discount` en /cart/update.js SUSTITUYE los códigos del carrito (probado:
     con NOSVEMOS15 puesto y enviando LUCABREF, el carrito se queda solo con
     LUCABREF). Con cadena vacía, los quita todos. Es la única forma de que
     mande el último escaneado: al visitar /discount/OTRO, Shopify los SUMA. */
  function escribirCodigo(valor) {
    ajustando = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: valor })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) { ajustando = false; return cart; });
  }

  function codigosDelCarrito(cart) {
    return (cart && cart.discount_codes ? cart.discount_codes : []).map(function (c) {
      return String(c.code || '').toUpperCase();
    }).filter(Boolean);
  }

  function borrarAvisos() {
    var strip = document.querySelector('.nsq-strip');
    if (strip) strip.remove();
    document.querySelectorAll('[data-nsq-tag]').forEach(function (tag) { tag.remove(); });
  }

  // -- Estado: qué código trae el cliente y cuánto descuenta -----------------
  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function apply(cart) {
    var raw = cart && cart.discount_codes && cart.discount_codes.length ? cart.discount_codes.slice() : [];
    if (!raw.length) {
      var loose = cookieCode() || urlCode();
      if (loose) raw = [{ code: loose, applicable: null }];
    }
    if (!raw.length) return false;

    var items = cart ? cart.item_count : 0;
    var list = [];

    raw.forEach(function (entry) {
      var code = String((entry && entry.code) || '').toUpperCase();
      if (!code) return;
      var known = CODES[code];

      // Shopify engancha al carrito CUALQUIER código escrito en el enlace,
      // exista o no, y con el carrito vacío no dice si vale (comprobado con un
      // código inventado). Solo hablamos de un código si está en la lista del
      // editor o si Shopify ya confirma que se aplica: nunca prometemos un
      // descuento que luego no se cobra.
      if (!known && entry.applicable !== true) return;

      list.push({
        code: code,
        pct: known ? known.pct : null,
        phrase: known ? known.phrase : '',
        rejected: items > 0 && entry.applicable === false
      });
    });
    if (!list.length) return false;

    // Con productos en el carrito manda Shopify: dice el porcentaje real de
    // cada código, y si alguno es de importe fijo no se puede estimar precio.
    if (cart && cart.cart_level_discount_applications) {
      cart.cart_level_discount_applications.forEach(function (d) {
        if (!d) return;
        var title = String(d.title).toUpperCase();
        list.forEach(function (it) {
          if (it.code !== title) return;
          if (d.value_type === 'percentage') {
            var v = parseFloat(d.value);
            if (!isNaN(v) && v > 0) it.pct = v;
          } else {
            it.pct = null;
          }
        });
      });
    }

    var active = list.filter(function (it) { return !it.rejected; });
    var withPct = active.filter(function (it) { return it.pct; });

    state.cart = cart;
    state.items = items;
    state.list = list;
    state.rejected = active.length === 0;
    state.codes = (active.length ? active : list).map(function (it) { return it.code; });
    state.code = state.codes.join(' + ');
    // Dos códigos pueden acumularse (comprobado: 15 % + 10 % = 25 % sobre el
    // precio original, no uno sobre otro), así que se suman.
    state.pct = active.length && withPct.length === active.length
      ? Math.min(withPct.reduce(function (a, it) { return a + it.pct; }, 0), 90)
      : null;
    state.phrase = '';
    (active.length ? active : list).some(function (it) {
      if (it.phrase) { state.phrase = it.phrase; return true; }
      return false;
    });
    return true;
  }

  // -- Franja de arriba ------------------------------------------------------
  function strip() {
    var el = document.querySelector('.nsq-strip');
    if (store('nsq-strip-off') === state.code) {
      if (el) el.remove();
      return;
    }

    var many = state.codes.length > 1;
    var verbo = many ? 'activados' : 'activado';
    var text;
    if (state.rejected) {
      text = '<b>' + state.code + '</b> · ' + (many ? 'estos códigos no se aplican' : 'este código no se aplica') +
        ' a lo que llevas en el carrito';
    } else if (state.pct) {
      text = '<b>' + state.code + '</b> ' + verbo + ' · ' + fmtPct(state.pct) + ' de descuento en tu pedido';
    } else {
      text = '<b>' + state.code + '</b> ' + verbo + ' · verás el descuento en el carrito';
    }

    if (el) {
      el.querySelector('span').innerHTML = text;
      return;
    }

    el = document.createElement('div');
    el.className = 'nsq-strip';
    el.setAttribute('role', 'status');
    el.innerHTML = CHECK + '<span>' + text + '</span>' +
      '<button type="button" class="nsq-strip-x" aria-label="Ocultar el aviso del código">&times;</button>';
    el.querySelector('.nsq-strip-x').addEventListener('click', function () {
      store('nsq-strip-off', state.code);
      el.remove();
    });
    document.body.insertBefore(el, document.body.firstChild);
  }

  function fmtPct(pct) {
    // Espacio duro: "15 %" nunca debe partirse entre dos líneas.
    return (Math.round(pct * 10) / 10).toString().replace('.', ',') + '\u00a0%';
  }

  // -- Bienvenida ------------------------------------------------------------
  function sheet() {
    if (sheetShown || document.querySelector('.nsq-sheet')) return;
    if (state.rejected) return;
    if (store('nsq-seen-' + state.code) === '1') return;
    store('nsq-seen-' + state.code, '1');
    sheetShown = true;

    var title = state.pct
      ? 'Tu ' + fmtPct(state.pct) + ' ya está activado'
      : (state.codes.length > 1 ? 'Tus códigos ya están activados' : 'Tu código ya está activado');
    var phrase = state.phrase || 'Ya está aplicado, no tienes que escribir nada.';
    var tail = state.pct
      ? ' El descuento se resta solo al pagar.'
      : ' Verás el descuento en cuanto añadas tu pack al carrito.';

    var wrap = document.createElement('div');
    wrap.className = 'nsq-sheet';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'nsq-sheet-title');
    wrap.innerHTML =
      '<div class="nsq-card">' +
        '<p class="nsq-ok">' + CHECK + 'Código aplicado</p>' +
        '<h2 id="nsq-sheet-title">' + title + '</h2>' +
        '<p class="nsq-sub"><strong>' + state.code + '</strong> · ' + phrase + tail + '</p>' +
        '<div class="nsq-actions">' +
          '<a class="nsq-btn" href="' + (conf.product_url || '/collections/all') + '">Elegir mi pack</a>' +
          '<button type="button" class="nsq-later">Seguir mirando</button>' +
        '</div>' +
      '</div>';

    function close() {
      wrap.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    wrap.querySelector('.nsq-later').addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', onKey);

    // En la ficha ya está el pack delante: el botón solo cierra.
    var cta = wrap.querySelector('.nsq-btn');
    if (document.getElementById('uaf-buybox-v2')) {
      cta.removeAttribute('href');
      cta.setAttribute('role', 'button');
      cta.textContent = 'Ver mis precios';
      cta.addEventListener('click', close);
    }

    document.body.appendChild(wrap);
    cta.focus({ preventScroll: true });
  }

  // -- Precios con el código -------------------------------------------------
  function tagFor(cents, variant) {
    var el = document.createElement('span');
    el.className = 'nsq-tag' + (variant ? ' nsq-tag--' + variant : '');
    el.setAttribute('data-nsq-tag', '');
    var many = state.codes.length > 1;
    el.innerHTML = '<em>' + money(withCode(cents, state.pct)) + '</em> ' +
      (variant === 'mini'
        ? (many ? 'con códigos' : 'con código')
        : (many ? 'con tus códigos' : 'con tu código'));
    return el;
  }

  function put(node, cents, where, variant) {
    if (!node || !cents) return;
    var old = where === 'in' ? node.querySelector(':scope > [data-nsq-tag]') : null;
    if (!old && node.nextElementSibling && node.nextElementSibling.hasAttribute &&
        node.nextElementSibling.hasAttribute('data-nsq-tag')) {
      old = node.nextElementSibling;
    }
    var tag = tagFor(cents, variant);
    if (old) { old.replaceWith(tag); return; }
    if (where === 'in') node.appendChild(tag);
    else node.insertAdjacentElement('afterend', tag);
  }

  function prices() {
    if (!state.pct || state.rejected) return;

    // Portada: precio "Desde" del hero y cada pack. La etiqueta va DENTRO del
    // párrafo: en móvil el hero es una rejilla ordenada y un hermano suelto se
    // colaría delante del titular.
    var from = document.querySelector('.nsp-from');
    if (from) put(from, parseCents((from.querySelector('strong') || from).textContent), 'in');
    document.querySelectorAll('.nsp-pack-price').forEach(function (p) {
      put(p, parseCents(p.textContent), 'after');
    });

    // Catálogo. Las tarjetas de color agotado no llevan etiqueta: anunciar un
    // precio con descuento de algo que no se puede comprar solo despista.
    document.querySelectorAll('.nspc-card-price').forEach(function (cp) {
      var card = cp.closest('.nspc-card') || cp.parentElement;
      if (card && /agotado/i.test(card.textContent)) return;
      put(cp, parseCents(cp.textContent), 'after');
    });
    document.querySelectorAll('.nspc-pack-price').forEach(function (p) {
      put(p, parseCents(p.querySelector('strong') ? p.querySelector('strong').textContent : p.textContent), 'after');
    });

    // Ficha de producto: precio grande y cada pack
    var line = document.querySelector('#uaf-buybox-v2 .uafp__price-line');
    if (line) {
      var main = document.getElementById('uafp-main-price');
      put(line, parseCents(main ? main.textContent : line.textContent), 'after');
    }
    document.querySelectorAll('#uaf-buybox-v2 .uafp__pack-price').forEach(function (p) {
      var strong = p.querySelector('strong');
      put(p, parseCents(strong ? strong.textContent : p.textContent), 'in');
    });

    // Barra fija de la ficha: la línea va debajo del precio, en su columna,
    // que al lado no cabe y parte el título en dos.
    var sticky = document.getElementById('uafp-sticky-price');
    if (sticky) {
      var info = sticky.closest('.uafp__sticky-info');
      put(info || sticky, parseCents(sticky.textContent), info ? 'in' : 'after', 'mini');
    }
  }

  // -- Carrito: decir qué código es y cuánto quita ---------------------------
  // La misma fila existe en la página del carrito y en el carrito lateral, que
  // se pinta al abrirlo: por eso se recorren todas y se repinta cuando cambian.
  // Sin la palabra "Código" delante: en un móvil de 375 px partía en dos líneas.
  function cartRows() {
    if (!state.cart || !state.cart.total_discount) return;
    var pct = state.pct ? ' · −' + fmtPct(state.pct) : '';
    var texto = state.code + pct;
    document.querySelectorAll('.nsc-saving').forEach(function (row) {
      var label = row.querySelector('span');
      if (!label || label.getAttribute('data-nsq-row') === texto) return;
      row.classList.add('nsq-cartrow');
      label.setAttribute('data-nsq-row', texto);
      label.innerHTML = CHECK + '<span>' + texto + '</span>';
    });
  }

  // El aviso de cookies de Shopify es lo primero que hay que contestar: la
  // bienvenida espera a que desaparezca para no salir una encima de otra.
  function whenFreeOfBanners(fn) {
    var tries = 0;
    // Ojo: el aviso va en position:fixed y ahí offsetParent siempre es null;
    // se mira la caja de verdad.
    function banner() {
      var b = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
      if (!b) return false;
      var css = window.getComputedStyle(b);
      return css.display !== 'none' && css.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
    }
    // El aviso de cookies lo pinta Shopify con su propio script: damos un
    // margen antes de mirar, o llegaríamos antes que él.
    setTimeout(function check() {
      if (!banner()) { fn(); return; }
      if (++tries > 120) return;
      setTimeout(check, 500);
    }, 900);
  }

  // -- Pintar todo -----------------------------------------------------------
  function paint(firstTime) {
    strip();
    prices();
    cartRows();
    if (firstTime && (urlCode() || document.referrer.indexOf(window.location.host) === -1)) whenFreeOfBanners(sheet);
  }

  /* Qué código mandar. Regla del negocio: vale el ÚLTIMO que el cliente ha
     escaneado o escrito, no el que se le quedó pegado al carrito hace meses.
     - Llega por enlace (QR o ?discount=) → ese, y se borra el anterior.
     - Sin enlace, el que ya tenga el carrito, siempre que se escaneara hace
       menos de DIAS días (se apunta la fecha al llegar).
     - Más viejo que eso → se retira del carrito y la web no dice nada. */
  function refresh(firstTime) {
    if (ajustando) return Promise.resolve();
    return readCart().then(function (cart) {
      var enlace = (urlCode() || '').toUpperCase();
      var cookie = (cookieCode() || '').toUpperCase();
      var enCarrito = codigosDelCarrito(cart);
      var mem = recuerdo();

      var elegido = enlace || cookie;
      if (!elegido) {
        elegido = mem && enCarrito.indexOf(mem.code) >= 0 ? mem.code : (enCarrito[enCarrito.length - 1] || '');
      }
      if (!elegido) return;

      // Caducidad: solo cuenta la fecha de cuando llegó, no las visitas.
      var esNuevo = !!enlace || !mem || mem.code !== elegido;
      if (!esNuevo && mem && Date.now() - mem.ts > DIAS * 86400000) {
        return escribirCodigo('').then(function () {
          olvidar();
          borrarAvisos();
        });
      }
      if (esNuevo) recordar(elegido);

      // Que en el carrito quede SOLO ese: si no, se acumulan y se suman
      // descuentos de visitas distintas (comprobado con dos QR seguidos).
      var yaSolo = enCarrito.length === 1 && enCarrito[0] === elegido;
      if (!yaSolo) {
        return escribirCodigo(elegido).then(function (actualizado) {
          if (apply(actualizado || cart)) paint(firstTime);
        });
      }

      if (apply(cart)) paint(firstTime);
    });
  }

  function watch() {
    // El precio grande de la ficha cambia al elegir pack: la etiqueta le sigue.
    var main = document.getElementById('uafp-main-price');
    if (main && window.MutationObserver) {
      new MutationObserver(function () { prices(); }).observe(main, { childList: true, characterData: true, subtree: true });
    }
    var packs = document.querySelector('#uaf-buybox-v2 .uafp__packs');
    if (packs) packs.addEventListener('change', function () { setTimeout(prices, 60); });

    // Cualquier cambio del carrito (añadir, quitar, cantidades) repinta.
    if (window.fetch) {
      var real = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = real.apply(this, arguments);
        if (url.indexOf('/cart/') !== -1) p.then(function () { setTimeout(function () { refresh(false); }, 120); });
        return p;
      };
    }
    document.addEventListener('ns-club:refresh', function () { refresh(false); });

    // El carrito lateral y el cajón del tema se pintan al abrirlos: en cuanto
    // cambian por dentro, la fila del código se vuelve a escribir.
    if (window.MutationObserver) {
      ['#ns-cart-panel', 'cart-drawer', '#CartDrawer'].forEach(function (sel) {
        var node = document.querySelector(sel);
        if (!node) return;
        new MutationObserver(function () { cartRows(); }).observe(node, { childList: true, subtree: true });
      });
    }
  }

  function boot() {
    refresh(true).then(watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
